export default __webpack_public_path__ + "static/media/how-many-minutes.2a06616f.png";